// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import styled from 'styled-components';
// import { navigationData } from '../../data/gemstoneData';

// const NavContainer = styled.nav`
//   background: white;
//   border-bottom: 1px solid rgba(0,0,0,0.05);
//   position: sticky;
//   top: 0;
//   z-index: 1000;
//   box-shadow: 0 2px 10px rgba(0,0,0,0.02);
// `;

// const NavWrapper = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
//   padding: 0 40px;
// `;

// const MainNav = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   height: 80px;
// `;

// const Logo = styled(Link)`
//   font-family: 'Playfair Display', serif;
//   font-size: 28px;
//   letter-spacing: 3px;
//   color: #1a2a3a;
//   cursor: pointer;
//   text-decoration: none;
//   transition: color 0.3s ease;
  
//   &:hover {
//     color: #c4a484;
//   }
  
//   span {
//     color: #c4a484;
//     font-size: 12px;
//     display: block;
//     letter-spacing: 4px;
//     text-transform: uppercase;
//     margin-top: 4px;
//     transition: color 0.3s ease;
//   }
  
//   &:hover span {
//     color: #1a2a3a;
//   }
// `;

// const NavItems = styled.div`
//   display: flex;
//   gap: 30px;
// `;

// const NavItem = styled.div`
//   position: relative;
// `;

// const NavButton = styled(Link)`
//   background: none;
//   border: none;
//   font-size: 14px;
//   letter-spacing: 1px;
//   text-transform: uppercase;
//   color: #2c3e50;
//   cursor: pointer;
//   padding: 10px 0;
//   font-weight: 500;
//   white-space: nowrap;
//   text-decoration: none;
//   display: block;
//   transition: color 0.3s ease;
  
//   &:hover {
//     color: #c4a484;
//   }
// `;

// const DropdownMenu = styled.div`
//   position: absolute;
//   top: 100%;
//   left: 50%;
//   transform: translateX(-50%);
//   background: white;
//   min-width: 250px;
//   box-shadow: 0 10px 30px rgba(0,0,0,0.1);
//   border-radius: 4px;
//   padding: 15px 0;
//   opacity: ${props => props.isOpen ? 1 : 0};
//   visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
//   transition: all 0.3s ease;
//   z-index: 1000;
// `;

// const DropdownItem = styled(Link)`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 10px 20px;
//   color: #2c3e50;
//   text-decoration: none;
//   font-size: 13px;
//   transition: all 0.2s;
  
//   &:hover {
//     background: #f8f9fa;
//     color: #c4a484;
//     padding-left: 25px;
//   }
// `;

// const Tag = styled.span`
//   background: ${props => {
//     if (props.tag === 'HOT') return '#ff4757';
//     if (props.tag === 'NEW') return '#2ecc71';
//     if (props.tag === 'SALE') return '#f39c12';
//     return '#c4a484';
//   }};
//   color: white;
//   font-size: 10px;
//   padding: 2px 6px;
//   border-radius: 3px;
//   text-transform: uppercase;
//   margin-left: 10px;
//   font-weight: 600;
// `;

// const DropdownNav = () => {
//   const [openDropdown, setOpenDropdown] = useState(null);

//   // Check if navigationData exists
//   if (!navigationData) {
//     console.error('navigationData is not defined');
//     return (
//       <NavContainer>
//         <NavWrapper>
//           <MainNav>
//             <Logo to="/">VALORA GEMS<span>FIFTH AVENUE • NEW YORK</span></Logo>
//           </MainNav>
//         </NavWrapper>
//       </NavContainer>
//     );
//   }

//   // Special category mapping - routes non-gem items to proper pages
//   const getCategoryPath = (name) => {
//     const lowerName = name.toLowerCase();
    
//     // Map category names to their proper routes
//     if (lowerName === 'new arrivals') return '/new-arrivals';
//     if (lowerName === 'gems on sale') return '/on-sale';
//     if (lowerName === 'gemstone type') return '/view-all';
//     if (lowerName === 'gems online') return '/view-all';
//     if (lowerName === 'rare gemstones') return '/view-all';
//     if (lowerName === 'recommended gems') return '/view-all';
//     if (lowerName === 'gem auctions') return '/view-all';
    
//     // Default: treat as a gem detail page
//     return `/gem/${name.toLowerCase().replace(/\s+/g, '-')}`;
//   };

//   const renderDropdownItems = (items) => {
//     if (!items || !Array.isArray(items) || items.length === 0) {
//       return <DropdownItem to="#">No items available</DropdownItem>;
//     }

//     return items.map((item, index) => {
//       if (typeof item === 'string') {
//         // Get proper path for this item
//         const path = getCategoryPath(item);
//         return (
//           <DropdownItem key={index} to={path}>
//             {item}
//           </DropdownItem>
//         );
//       }
      
//       if (item && typeof item === 'object' && item.name) {
//         // Get proper path for this item
//         const path = getCategoryPath(item.name);
//         return (
//           <DropdownItem key={index} to={path}>
//             {item.name}
//             {item.tag && <Tag tag={item.tag}>{item.tag}</Tag>}
//           </DropdownItem>
//         );
//       }
      
//       return null;
//     });
//   };

//   const handleMouseEnter = (dropdown) => {
//     setOpenDropdown(dropdown);
//   };

//   const handleMouseLeave = () => {
//     setOpenDropdown(null);
//   };

//   return (
//     <NavContainer>
//       <NavWrapper>
//         <MainNav>
//           <Logo to="/">
//             VALORA GEMS
//             <span>FIFTH AVENUE • NEW YORK</span>
//           </Logo>
          
//           <NavItems>
//             <NavItem 
//               onMouseEnter={() => handleMouseEnter('precious')}
//               onMouseLeave={handleMouseLeave}
//             >
//               <NavButton to="/precious-gems">Precious Gems</NavButton>
//               <DropdownMenu isOpen={openDropdown === 'precious'}>
//                 {renderDropdownItems(navigationData.precious)}
//               </DropdownMenu>
//             </NavItem>

//             <NavItem 
//               onMouseEnter={() => handleMouseEnter('fine')}
//               onMouseLeave={handleMouseLeave}
//             >
//               <NavButton to="/fine-gems">Fine Gems</NavButton>
//               <DropdownMenu isOpen={openDropdown === 'fine'}>
//                 {renderDropdownItems(navigationData.fine)}
//               </DropdownMenu>
//             </NavItem>

//             <NavItem 
//               onMouseEnter={() => handleMouseEnter('tourmaline')}
//               onMouseLeave={handleMouseLeave}
//             >
//               <NavButton to="/tourmaline">Tourmaline</NavButton>
//               <DropdownMenu isOpen={openDropdown === 'tourmaline'}>
//                 {renderDropdownItems(navigationData.tourmaline)}
//               </DropdownMenu>
//             </NavItem>

//             <NavItem 
//               onMouseEnter={() => handleMouseEnter('garnets')}
//               onMouseLeave={handleMouseLeave}
//             >
//               <NavButton to="/garnets">Garnets</NavButton>
//               <DropdownMenu isOpen={openDropdown === 'garnets'}>
//                 {renderDropdownItems(navigationData.garnets)}
//               </DropdownMenu>
//             </NavItem>

//             <NavItem 
//               onMouseEnter={() => handleMouseEnter('viewAll')}
//               onMouseLeave={handleMouseLeave}
//             >
//               <NavButton to="/view-all">View All</NavButton>
//               <DropdownMenu isOpen={openDropdown === 'viewAll'}>
//                 {renderDropdownItems(navigationData.viewAll)}
//               </DropdownMenu>
//             </NavItem>
//           </NavItems>
//         </MainNav>
//       </NavWrapper>
//     </NavContainer>
//   );
// };

// export default DropdownNav;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { navigationData } from '../../data/gemstoneData';
import ProfileDropdown from '../Auth/ProfileDropdown';

const NavContainer = styled.nav`
  background: white;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0,0,0,0.02);
`;

const NavWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const MainNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
`;

const Logo = styled(Link)`
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  letter-spacing: 3px;
  color: #1a2a3a;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease;
  flex-shrink: 0;

  &:hover {
    color: #c4a484;
  }

  span {
    color: #c4a484;
    font-size: 12px;
    display: block;
    letter-spacing: 4px;
    text-transform: uppercase;
    margin-top: 4px;
    transition: color 0.3s ease;
  }

  &:hover span {
    color: #1a2a3a;
  }

  @media (max-width: 768px) {
    font-size: 22px;
    letter-spacing: 2px;

    span {
      font-size: 10px;
      letter-spacing: 3px;
    }
  }
`;

const NavItems = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;

  @media (max-width: 968px) {
    display: none;
  }
`;

const NavItem = styled.div`
  position: relative;
`;

const NavButton = styled(Link)`
  background: none;
  border: none;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #2c3e50;
  cursor: pointer;
  padding: 10px 0;
  font-weight: 500;
  white-space: nowrap;
  text-decoration: none;
  display: block;
  transition: color 0.3s ease;

  &:hover {
    color: #c4a484;
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  min-width: 250px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 15px 0;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  z-index: 1000;
`;

const DropdownItem = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  color: #2c3e50;
  text-decoration: none;
  font-size: 13px;
  transition: all 0.2s;

  &:hover {
    background: #f8f9fa;
    color: #c4a484;
    padding-left: 25px;
  }
`;

const Tag = styled.span`
  background: ${props => {
    if (props.$tag === 'HOT') return '#ff4757';
    if (props.$tag === 'NEW') return '#2ecc71';
    if (props.$tag === 'SALE') return '#f39c12';
    return '#c4a484';
  }};
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
  text-transform: uppercase;
  margin-left: 10px;
  font-weight: 600;
`;

// Auth button styles
const AuthButtons = styled.div`
  display: flex;
  gap: 15px;
  margin-left: 20px;
`;

const LoginNavButton = styled.button`
  background: transparent;
  border: 1.5px solid #c4a484;
  color: #c4a484;
  padding: 6px 20px;
  border-radius: 30px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: #c4a484;
    color: white;
    transform: translateY(-2px);
  }
`;

const SignupNavButton = styled.button`
  background: #c4a484;
  border: none;
  color: white;
  padding: 6px 20px;
  border-radius: 30px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: #b89474;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(196, 164, 132, 0.3);
  }
`;

// Mobile hamburger button
const HamburgerButton = styled.button`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 1100;

  @media (max-width: 968px) {
    display: flex;
  }
`;

const HamburgerLine = styled.span`
  display: block;
  width: 24px;
  height: 2px;
  background: #1a2a3a;
  border-radius: 2px;
  transition: all 0.3s ease;

  &:nth-child(1) {
    transform: ${props => props.$open ? 'translateY(7px) rotate(45deg)' : 'none'};
  }
  &:nth-child(2) {
    opacity: ${props => props.$open ? 0 : 1};
  }
  &:nth-child(3) {
    transform: ${props => props.$open ? 'translateY(-7px) rotate(-45deg)' : 'none'};
  }
`;

// Mobile drawer overlay
const MobileOverlay = styled.div`
  display: none;

  @media (max-width: 968px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 1050;
    opacity: ${props => props.$open ? 1 : 0};
    pointer-events: ${props => props.$open ? 'all' : 'none'};
    transition: opacity 0.3s ease;
  }
`;

// Mobile drawer panel
const MobileDrawer = styled.div`
  display: none;

  @media (max-width: 968px) {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    width: 280px;
    height: 100%;
    background: white;
    z-index: 1100;
    padding: 100px 0 40px;
    overflow-y: auto;
    transform: ${props => props.$open ? 'translateX(0)' : 'translateX(100%)'};
    transition: transform 0.35s ease;
    box-shadow: -4px 0 20px rgba(0,0,0,0.1);
  }
`;

const MobileNavLink = styled(Link)`
  display: block;
  padding: 14px 30px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #2c3e50;
  text-decoration: none;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  transition: color 0.2s, background 0.2s;

  &:hover {
    color: #c4a484;
    background: #faf8f5;
  }
`;

const MobileAuthButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 30px 0;
`;

const MobileLoginButton = styled.button`
  background: transparent;
  border: 1.5px solid #c4a484;
  color: #c4a484;
  padding: 10px 20px;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: #c4a484;
    color: white;
  }
`;

const MobileSignupButton = styled.button`
  background: #c4a484;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 30px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background: #b89474;
  }
`;

const DropdownNav = ({ 
  isAuthenticated, 
  user, 
  onLogout, 
  onOpenLogin, 
  onOpenSignup, 
  onOpenSettings 
}) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  // Check if navigationData exists
  if (!navigationData) {
    console.error('navigationData is not defined');
    return (
      <NavContainer>
        <NavWrapper>
          <MainNav>
            <Logo to="/">VALORA GEMS<span>FIFTH AVENUE • NEW YORK</span></Logo>
          </MainNav>
        </NavWrapper>
      </NavContainer>
    );
  }

  // Special category mapping - routes non-gem items to proper pages
  const getCategoryPath = (name) => {
    const lowerName = name.toLowerCase();
    
    // Map category names to their proper routes
    if (lowerName === 'new arrivals') return '/new-arrivals';
    if (lowerName === 'gems on sale') return '/on-sale';
    if (lowerName === 'gemstone type') return '/view-all';
    if (lowerName === 'gems online') return '/view-all';
    if (lowerName === 'rare gemstones') return '/view-all';
    if (lowerName === 'recommended gems') return '/view-all';
    if (lowerName === 'gem auctions') return '/view-all';
    
    // Default: treat as a gem detail page
    return `/gem/${name.toLowerCase().replace(/\s+/g, '-')}`;
  };

  const renderDropdownItems = (items) => {
    if (!items || !Array.isArray(items) || items.length === 0) {
      return <DropdownItem to="#">No items available</DropdownItem>;
    }

    return items.map((item, index) => {
      if (typeof item === 'string') {
        // Get proper path for this item
        const path = getCategoryPath(item);
        return (
          <DropdownItem key={index} to={path}>
            {item}
          </DropdownItem>
        );
      }
      
      if (item && typeof item === 'object' && item.name) {
        // Get proper path for this item
        const path = getCategoryPath(item.name);
        return (
          <DropdownItem key={index} to={path}>
            {item.name}
            {item.tag && <Tag $tag={item.tag}>{item.tag}</Tag>}
          </DropdownItem>
        );
      }
      
      return null;
    });
  };

  const handleMouseEnter = (dropdown) => {
    setOpenDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  return (
    <>
      <NavContainer>
        <NavWrapper>
          <MainNav>
            <Logo to="/">
              CEY-VALORA
              <span>ATLANTA • GEORGIA</span>
            </Logo>

            {/* Desktop nav */}
            <NavItems>
              <NavItem
                onMouseEnter={() => handleMouseEnter('precious')}
                onMouseLeave={handleMouseLeave}
              >
                <NavButton to="/precious-gems">Precious Gems</NavButton>
                <DropdownMenu $isOpen={openDropdown === 'precious'}>
                  {renderDropdownItems(navigationData.precious)}
                </DropdownMenu>
              </NavItem>

              <NavItem
                onMouseEnter={() => handleMouseEnter('fine')}
                onMouseLeave={handleMouseLeave}
              >
                <NavButton to="/fine-gems">Fine Gems</NavButton>
                <DropdownMenu $isOpen={openDropdown === 'fine'}>
                  {renderDropdownItems(navigationData.fine)}
                </DropdownMenu>
              </NavItem>

              <NavItem
                onMouseEnter={() => handleMouseEnter('tourmaline')}
                onMouseLeave={handleMouseLeave}
              >
                <NavButton to="/tourmaline">Tourmaline</NavButton>
                <DropdownMenu $isOpen={openDropdown === 'tourmaline'}>
                  {renderDropdownItems(navigationData.tourmaline)}
                </DropdownMenu>
              </NavItem>

              <NavItem
                onMouseEnter={() => handleMouseEnter('garnets')}
                onMouseLeave={handleMouseLeave}
              >
                <NavButton to="/garnets">Garnets</NavButton>
                <DropdownMenu $isOpen={openDropdown === 'garnets'}>
                  {renderDropdownItems(navigationData.garnets)}
                </DropdownMenu>
              </NavItem>

              <NavItem
                onMouseEnter={() => handleMouseEnter('viewAll')}
                onMouseLeave={handleMouseLeave}
              >
                <NavButton to="/view-all">View All</NavButton>
                <DropdownMenu $isOpen={openDropdown === 'viewAll'}>
                  {renderDropdownItems(navigationData.viewAll)}
                </DropdownMenu>
              </NavItem>

              <AuthButtons>
                {isAuthenticated && user ? (
                  <ProfileDropdown
                    user={user}
                    onLogout={onLogout}
                    onOpenSettings={onOpenSettings}
                  />
                ) : (
                  <>
                    <LoginNavButton onClick={onOpenLogin}>Login</LoginNavButton>
                    <SignupNavButton onClick={onOpenSignup}>Sign Up</SignupNavButton>
                  </>
                )}
              </AuthButtons>
            </NavItems>

            {/* Hamburger button - mobile only */}
            <HamburgerButton
              aria-label="Toggle menu"
              onClick={() => setMobileOpen(prev => !prev)}
            >
              <HamburgerLine $open={mobileOpen} />
              <HamburgerLine $open={mobileOpen} />
              <HamburgerLine $open={mobileOpen} />
            </HamburgerButton>
          </MainNav>
        </NavWrapper>
      </NavContainer>

      {/* Mobile overlay */}
      <MobileOverlay $open={mobileOpen} onClick={closeMobile} />

      {/* Mobile slide-in drawer */}
      <MobileDrawer $open={mobileOpen}>
        <MobileNavLink to="/precious-gems" onClick={closeMobile}>Precious Gems</MobileNavLink>
        <MobileNavLink to="/fine-gems" onClick={closeMobile}>Fine Gems</MobileNavLink>
        <MobileNavLink to="/tourmaline" onClick={closeMobile}>Tourmaline</MobileNavLink>
        <MobileNavLink to="/garnets" onClick={closeMobile}>Garnets</MobileNavLink>
        <MobileNavLink to="/view-all" onClick={closeMobile}>View All</MobileNavLink>

        <MobileAuthButtons>
          {isAuthenticated && user ? (
            <MobileLoginButton onClick={() => { onLogout(); closeMobile(); }}>
              Logout
            </MobileLoginButton>
          ) : (
            <>
              <MobileLoginButton onClick={() => { onOpenLogin(); closeMobile(); }}>Login</MobileLoginButton>
              <MobileSignupButton onClick={() => { onOpenSignup(); closeMobile(); }}>Sign Up</MobileSignupButton>
            </>
          )}
        </MobileAuthButtons>
      </MobileDrawer>
    </>
  );
};

export default DropdownNav;
